const config = {
  API_URL: process.env.REACT_APP_API_URL,
  COMPILE_URL: process.env.REACT_APP_COMPILE_URL,
};

export default config;
